import styled from 'styled-components';

export const Header = styled.header`
  header {
    // We give bg color to the header here...
    background-color: var(--header_bg) !important;
    border-bottom: 1px solid ${({ theme }) => theme.colors.quoteBgc};

    .headerTheme {
      //border-bottom: 1px solid ${({ theme }) => theme.colors.border};
      #userMenu {
        button:hover {
          color: ${({ theme }) => theme.colors.quoteBgc} !important;
        }
        .headerDropdown {
          //border: 1px solid red !important;
          color: red;
          :hover {
            color: red !important;
          }
          button.ant-btn-compact-last-item {
            span {
              svg {
                path {
                  fill: 'red';
                }
              }
            }
          }
        }
        #notificationIcon,
        #theme-switcher-container {
          border-right: 1px solid ${({ theme }) => theme.colors.quoteBgc};
        }

        #searchButton {
          border-top: 1px solid ${({ theme }) => theme.colors.quoteBgc};
          border-bottom: 1px solid ${({ theme }) => theme.colors.quoteBgc};
          padding: 5px 0 5px 0;
          // span {
          //   //search input box ile iconu arasındaki çizgi
          //   span {
          //     :nth-child(2) {
          //       border-right: 1px solid ${({ theme }) => theme.colors.quoteBgc} !important;
          //     }
          //   }
          // }
          .ant-input-wrapper {
            border-left: 1px solid ${({ theme }) => theme.colors.quoteBgc};
          }
        }
      }
    }
  }
`;
